module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container section"
  }, [(_vm.localEnv) ? _c('div', [(_vm.localEnv) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }, [_vm._v("\n                getData()\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Inspiration til, hvor der kan sættes ind for at øge indtjeningen og likviditeten</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Vælg et område og se nogle eksempler på, hvordan virksomheden kan øge indtjeningen.\n            ")])]), _vm._v(" "), (!_vm.loading && _vm.textsLoaded === this.identifiers.length) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "-30px",
      "height": "30px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin-bottom": "30px",
      "font-weight": "bold"
    }
  }, [(_vm.selectedMenuItem) ? _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectedMenuItem = null;
        _vm.selectedBox = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-fw fa-arrow-left"
  }), _vm._v(" Tilbage til oversigt")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Alle beregninger er baseret på de seneste 12 hele måneders resultater\n                (" + _vm._s(_vm._f("moment")(_vm.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.to, 'DD/MM/YYYY')) + ")\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem),
      expression: "selectedMenuItem"
    }],
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'economy'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('economy')
      }
    }
  }, [_c('span', [_vm._v("Økonomi")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'customers'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('customers')
      }
    }
  }, [_c('span', [_vm._v("Kunder")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'projects'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('projects')
      }
    }
  }, [_c('span', [_vm._v("Opgaver")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'employees'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('employees')
      }
    }
  }, [_c('span', [_vm._v("Medarbejdere")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'potential'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('potential')
      }
    }
  }, [_c('span', [_vm._v("Potentiale")])])])]), _vm._v(" "), (!_vm.selectedMenuItem) ? _c('div', {
    staticClass: "ai-insight-box"
  }, [_c('div', {
    staticClass: "ai-insight-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ai-insight-actions"
  }, [(_vm.insight) ? _c('span', {
    staticClass: "ai-insight-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.insight.generated_at, 'DD/MM/YYYY HH:mm')))]) : _vm._e(), _vm._v(" "), (_vm.showHistory) ? _c('span', {
    staticClass: "ai-insight-history",
    on: {
      "click": function($event) {
        _vm.showHistory = false
      }
    }
  }, [_vm._v("Skjul historik")]) : (_vm.insightHistory.length > 0) ? _c('span', {
    staticClass: "ai-insight-history",
    on: {
      "click": _vm.loadHistory
    }
  }, [_vm._v("Vis historik")]) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin) ? _c('span', {
    staticClass: "ai-insight-regenerate",
    on: {
      "click": _vm.regenerateInsight
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.insightLoading
    }
  }), _vm._v(" Ny indsigt\n                        ")]) : _vm._e()])]), _vm._v(" "), (_vm.insightLoading && !_vm.insight) ? _c('div', {
    staticClass: "ai-insight-content"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  }), _vm._v(" Genererer indsigt...\n                ")]) : (_vm.insight) ? _c('div', {
    staticClass: "ai-insight-content",
    domProps: {
      "innerHTML": _vm._s(_vm.insight.insight)
    }
  }) : _c('div', {
    staticClass: "ai-insight-content ai-insight-empty"
  }, [_vm._v("\n                    Ingen indsigt tilgængelig endnu.\n                ")]), _vm._v(" "), (_vm.insight) ? _c('div', {
    staticClass: "ai-insight-footer"
  }, [_c('i', {
    staticClass: "fas fa-robot"
  }), _vm._v(" Genereret af AI baseret på jeres data. Indsigten er et forslag og bør altid vurderes i kontekst af jeres virksomhed.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.showHistory && _vm.insightHistory.length > 0) ? _c('div', {
    staticClass: "ai-insight-history-list"
  }, _vm._l((_vm.insightHistory), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ai-insight-history-item"
    }, [_c('span', {
      staticClass: "ai-insight-history-date"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.generated_at, 'DD/MM/YYYY')))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.insight)
      }
    })])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.selectedMenuItem) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'economy'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('economy')
      }
    }
  }, [_c('span', [_vm._v("Økonomi")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'projects')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.projects.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.totalOpenValue)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'aconto')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.aconto.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.economy.aconto.value)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'reminders')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.reminders.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.economy.reminders.value)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'customers'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('customers')
      }
    }
  }, [_c('span', [_vm._v("Kunder")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('customers', 'makingMoney')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.customers.makingMoney.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[0] : 0)) + " til " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[1] : 0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('customers', 'smallAndBig')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.customers.smallAndBig.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[0].coverage_per_hour)) + "\n                            "), _c('span', [_vm._v("Omsætning " + _vm._s(_vm.smallAndBigRange[0].name))])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[1].coverage_per_hour)) + "\n                            "), _c('span', [_vm._v("Omsætning " + _vm._s(_vm.smallAndBigRange[1].name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'projects'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('projects')
      }
    }
  }, [_c('span', [_vm._v("Opgaver")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'rightProjects')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.rightProjects.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[0])) + " til\n                            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[1])) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'mostImportant')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.mostImportantFirst.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[0].name) + "\n                                "), (_vm.projectsMostImportantRange[0].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_per_hour_change))))])])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [(_vm.projectsMostImportantRange.length > 1) ? _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[1].name) + "\n                                "), (_vm.projectsMostImportantRange[1].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_per_hour_change))))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'mostImportant')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.mostImportantSecond.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[0].name) + "\n                                "), (_vm.projectsMostImportantRange[0].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_change))))])])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [(_vm.projectsMostImportantRange.length > 1) ? _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[1].name) + "\n                                "), (_vm.projectsMostImportantRange[1].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_change))))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'employees'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('employees')
      }
    }
  }, [_c('span', [_vm._v("Medarbejdere")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'moreTime')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.moreTime.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.employees.more_time.possible_revenue_increase)) + "\n                            "), _c('span', [_vm._v("Kundetid i dag: " + _vm._s(_vm._f("number")(_vm.data.employees.more_time.percentage_with_customers)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'lessSickness')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.lessSickness.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.employees.less_sickness.possible_revenue_increase)) + "\n                            "), _c('span', [_vm._v("Sygefravær i dag: " + _vm._s(_vm._f("number")(_vm.data.employees.less_sickness.percentage)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'rightPeople')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.rightPeople.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.employeesRightPeoplePossibleRevenue)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'potential'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('potential')
      }
    }
  }, [_c('span', [_vm._v("Potentiale")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.potential.tekstPOverblik)
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.potential.tekstPOverblik) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "15px"
    }
  }, [_c('possible-efforts-economy', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'economy'),
      expression: "selectedMenuItem === 'economy'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.economy,
      "totalOpenValue": _vm.totalOpenValue,
      "totalAcontoValue": _vm.totalAcontoValue,
      "totalRemindersValue": _vm.totalRemindersValue,
      "texts": _vm.texts.economy
    }
  }), _vm._v(" "), _c('possible-efforts-customers', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'customers'),
      expression: "selectedMenuItem === 'customers'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.customers,
      "customersMakingMoneyRange": _vm.customersMakingMoneyRange,
      "smallAndBigRange": _vm.smallAndBigRange,
      "texts": _vm.texts.customers
    }
  }), _vm._v(" "), _c('possible-efforts-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'projects'),
      expression: "selectedMenuItem === 'projects'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.projects,
      "projectsRightProjectsRange": _vm.projectsRightProjectsRange,
      "projectsMostImportantRange": _vm.projectsMostImportantRange,
      "texts": _vm.texts.projects
    }
  }), _vm._v(" "), _c('possible-efforts-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'employees'),
      expression: "selectedMenuItem === 'employees'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.employees,
      "employeesRightPeoplePossibleRevenue": _vm.employeesRightPeoplePossibleRevenue,
      "projects": _vm.data.projects,
      "texts": _vm.texts.employees
    }
  })], 1)]) : _c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-lightbulb"
  }), _vm._v(" Dagens indsigt")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3390115e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/possibleEfforts.vue
// module id = 840
// module chunks = 0